import {
  SET_USER,
  SET_USER_PROJECTS,
  RESET_USER,
  GET_USER_EVENTS,
  ASYNC_START,
  ASYNC_END,
  GET_USER_WALLET,
  UPDATE_SOCIAL_NETWORKS,
  UPDATE_SKILLS_AND_ROLES,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  id: -1,
  username: '',
  email: '',
  raiting: 0,
  tokens: 0,
  facebook_id: '',
  tg_id: '',
  google_id: '',
  skills: [],
  roles: [],
  news: [],
  review: [],
  events: [],
  wallet: {
    rating: -1,
    tokens: -1,
    place: -1,
  },
  projects: [],
  _inProgress: false,
};

/**
* @param {Object} state - Default application state
* @param {Object} action - Action from action creator
* @returns {Object} New state
*/
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_USER:
      // TODO: It's fetched as Promise.all() -> comes in an array. Change that to single request when API will be fixed.
      const { payload } = action;
      if (!action.error) {

        return {
          ...payload[0].data, // setting general user data
          skills: Array.isArray(payload[0].data.skills) ? payload[0].data.skills : INITIAL_STATE.skills,
          roles: Array.isArray(payload[0].data.roles) ? payload[0].data.roles : INITIAL_STATE.roles,
          events: payload[1].data.map(event => event), // Events
          wallet: payload[2].data, // Wallet
          // projects: payload[3].data,
          _inProgress: false,
        };
      }
      return {
        ...state,
        error: action.error ? (Array.isArray(payload) ? payload[0].data : payload.data) : null
      };
    case SET_USER_PROJECTS:
      return {
        ...state,
        projects: action.payload.data,
      }
    case UPDATE_SKILLS_AND_ROLES:
      return {
        ...state,
        skills: Array.isArray(action.skills) ? action.skills : INITIAL_STATE.skills,
        roles: Array.isArray(action.roles) ? action.roles : INITIAL_STATE.roles,
      };
    case UPDATE_SOCIAL_NETWORKS:
      // TODO: Updating data. Not sure if correct implementation -_-
      return {
        ...state,
        ...action.socialNetworks,
      }
    case RESET_USER:
      return {
        ...INITIAL_STATE,
        _inProgress: state._inProgress,
      };
    case GET_USER_EVENTS:
      if (!action.error) {
        return {
          ...state,
          events: action.payload.data,
        };
      }
      return state;
    case GET_USER_WALLET:
      return {
        ...state,
        wallet: action.payload.data,
      }
    case ASYNC_START:
      if (action.subtype === SET_USER) {
        return {
          ...state,
          _inProgress: true,
        };
      }
      return state;
    case ASYNC_END:
      if (action.subtype === SET_USER) {
        return {
          ...state,
          _inProgress: false,
        };
      }
      return state;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/user.js